module.exports = __webpack_public_path__ + "static/img/checked.0a3ffb75.svg";